import React from "react";
import Table from "../../core/common/dataTable/index";
import { callsData } from "../../core/data/json/calls";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { TableData } from "../../core/data/interface";
import CollapseHeader from "../../core/common/collapse-header";
import DefaultEditor from "react-simple-wysiwyg";
const route = all_routes;

const EmailTemplate = () => {
  const dataSource = callsData;

  const columns = [
    {
      title: " Template Name",
      dataIndex: "name",
      sorter: (a: TableData, b: TableData) => a.title.length - b.title.length,
      key: "title",
      width: "172px",
    },
    {
      title: "Template Html",
      dataIndex: "host",
      sorter: (a: TableData, b: TableData) => a.title.length - b.title.length,
      key: "title",
      width: "272px",
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: TableData, b: TableData) => a.status.length - b.status.length,
      key: "status",
      width: "90px",
      render: (status: any) => (
        <span
          className={`${
            status == "Active"
              ? "badge badge-pill badge-status bg-success"
              : status == "Inactive"
              ? "badge badge-pill badge-status bg-danger"
              : ""
          }`}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "90px",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-target="#offcanvas_edit"
              data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_calls"
            >
              <i className="ti ti-trash text-danger" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-8">
                    <h4 className="page-title">
                      Email Template List
                      <span className="count-title">123</span>
                    </h4>
                  </div>
                  <div className="col-sm-4 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search "
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="text-sm-end">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          // data-bs-toggle="modal"
                          // data-bs-target="#add_calls"
                          data-bs-target="#offcanvas_add"
                          data-bs-toggle="offcanvas"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Email Template
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  {/* Calls List */}
                  <div className="table-responsive custom-table">
                    <Table columns={columns} dataSource={dataSource} />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Calls List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add New Calls */}
      <div className="modal fade" id="add_calls" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Call Reason</h5>
              <button
                className="btn-close custom-btn-close border p-1 me-0 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="mb-0">
                  <label className="col-form-label">Status</label>
                  <div className="d-flex align-items-center">
                    <div className="me-2">
                      <input
                        type="radio"
                        className="status-radio"
                        id="add-active"
                        name="status"
                        defaultChecked
                      />
                      <label htmlFor="add-active">Active</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        className="status-radio"
                        id="add-inactive"
                        name="status"
                      />
                      <label htmlFor="add-inactive">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="d-flex align-items-center justify-content-end m-0">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button type="button" className="btn btn-primary">
                    Create
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add New Calls */}
      {/* add api */}
      <div
        className="offcanvas  "
        style={{ width: "1250px", right: "0", top: "0" }}
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add Email Template</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="d-flex row">
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  {" "}
                  Template Name <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  {" "}
                  Subject <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  {" "}
                  Lead Placeholders <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_labels" className="form-select">
                    <option value="">Select to Insert</option>
                    <option value="[[Business Type]]">Business Type</option>
                    <option value="[[New Label]]">New Label</option>
                    <option value="[[Current Phone System]]">
                      Current Phone System
                    </option>
                    <option value="[[No of Open Loans]]">
                      No of Open Loans
                    </option>
                    <option value="[[Factor Rate]]">Factor Rate</option>
                    <option value="[[Annual Revenue]]">Annual Revenue</option>
                    <option value="[[Business Age]]">Business Age</option>
                    <option value="[[Credit Score]]">Credit Score</option>
                    <option value="[[Lead Source]]">Lead Source</option>
                    <option value="[[Monthly Revenue]]">Monthly Revenue</option>
                    <option value="[[First Name]]">First Name</option>
                    <option value="[[Email]]">Email</option>
                    <option value="[[Funding Amount]]">Funding Amount</option>
                    <option value="[[Zip]]">Zip</option>
                    <option value="[[State]]">State</option>
                    <option value="[[City]]">City</option>
                    <option value="[[Mobile]]">Mobile</option>
                    <option value="[[Work Phone]]">Work Phone</option>
                    <option value="[[Legal Company Name]]">
                      Legal Company Name
                    </option>
                    <option value="[[Last Name]]">Last Name</option>;
                  </select>
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label"> Sender Placeholders</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="">Select to Insert</option>
                    <option value="[[first_name]]">first_name</option>
                    <option value="[[last_name]]">last_name</option>
                    <option value="[[email]]">email</option>
                    <option value="[[mobile]]">mobile</option>
                    <option value="[[company_name]]">company_name</option>;
                  </select>
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  Custom Placeholders <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_custom_names" className="form-select">
                    <option value="">Select to Insert</option>
                    <option value="[[Facebook]]">Facebook</option>
                    <option value="[[Affiliate Link]]">Affiliate Link</option>;
                  </select>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <DefaultEditor className="summernote" />
                </div>
              </div>
            </div>
           
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-primary me-2"
              >
                Add
              </button>
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>
      {/* /add api */}
      {/* Edit Calls */}
      <div
        className="offcanvas "
        style={{ width: "1250px", right: "0", top: "0" }}
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Email Template</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="d-flex row">
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  {" "}
                  Template Name <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  {" "}
                  Subject <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  {" "}
                  Lead Placeholders <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_labels" className="form-select">
                    <option value="">Select to Insert</option>
                    <option value="[[Business Type]]">Business Type</option>
                    <option value="[[New Label]]">New Label</option>
                    <option value="[[Current Phone System]]">
                      Current Phone System
                    </option>
                    <option value="[[No of Open Loans]]">
                      No of Open Loans
                    </option>
                    <option value="[[Factor Rate]]">Factor Rate</option>
                    <option value="[[Annual Revenue]]">Annual Revenue</option>
                    <option value="[[Business Age]]">Business Age</option>
                    <option value="[[Credit Score]]">Credit Score</option>
                    <option value="[[Lead Source]]">Lead Source</option>
                    <option value="[[Monthly Revenue]]">Monthly Revenue</option>
                    <option value="[[First Name]]">First Name</option>
                    <option value="[[Email]]">Email</option>
                    <option value="[[Funding Amount]]">Funding Amount</option>
                    <option value="[[Zip]]">Zip</option>
                    <option value="[[State]]">State</option>
                    <option value="[[City]]">City</option>
                    <option value="[[Mobile]]">Mobile</option>
                    <option value="[[Work Phone]]">Work Phone</option>
                    <option value="[[Legal Company Name]]">
                      Legal Company Name
                    </option>
                    <option value="[[Last Name]]">Last Name</option>;
                  </select>
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label"> Sender Placeholders</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="">Select to Insert</option>
                    <option value="[[first_name]]">first_name</option>
                    <option value="[[last_name]]">last_name</option>
                    <option value="[[email]]">email</option>
                    <option value="[[mobile]]">mobile</option>
                    <option value="[[company_name]]">company_name</option>;
                  </select>
                </div>
              </div>
              <div className="mb-3 col-md-4">
                <label className="col-form-label">
                  Custom Placeholders <span className="text-danger">*</span>
                </label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_custom_names" className="form-select">
                    <option value="">Select to Insert</option>
                    <option value="[[Facebook]]">Facebook</option>
                    <option value="[[Affiliate Link]]">Affiliate Link</option>;
                  </select>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="col-form-label">
                    Description <span className="text-danger">*</span>
                  </label>
                  <DefaultEditor className="summernote" />
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-primary me-2"
              >
                Edit
              </button>
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit Calls */}
      {/* Delete Calls */}
      <div className="modal fade" id="delete_calls" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Confirm Delete</h4>
                <p className="mb-0">You are about to delete record.</p>
                <p className="mb-0">Do you want to proceed?</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                  >
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Calls */}
    </>
  );
};

export default EmailTemplate;
